const ADMIN_FEATURES = [
  "Transaction dashboard with filters and exports",
  "One-time and recurring charge creation",
  "Refund processing with full audit trail",
  "Tuition rate management by grade level",
  "Scholarship approval workflows",
  "Waitlist and enrollment management",
  "Lunch menu editor with A/B week rotation",
  "Mass email communications",
];

const PARENT_FEATURES = [
  "Single dashboard for all students",
  "Pay by credit card, debit, or bank transfer",
  "Saved payment methods with one-click pay",
  "Automatic receipts and payment history",
  "Online registration and elective enrollment",
  "Lunch ordering with recurring preferences",
  "Digital waiver and document signing",
  "Real-time balance and upcoming charges",
];

export default function Pricing() {
  return (
    <section className="section section-alt" id="pricing">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">What's included</p>
          <h2 className="section-title">One platform, two portals.</h2>
          <p className="section-lede">
            Your admin team and your families each get a dedicated experience
            built for what they need to do.
          </p>
        </header>
        <div className="highlight-grid">
          <div className="highlight-card">
            <h3>School admin portal</h3>
            <ul>
              {ADMIN_FEATURES.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>
          <div className="highlight-card">
            <h3>Parent portal</h3>
            <ul>
              {PARENT_FEATURES.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
